import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInsured, IPassportData, IAsylState } from '../types';

const initialState: IAsylState = {
  insureds: [], /// застрахованные
  period: null, /// Срок страхования
  coverage: null, /// сумма
  begin_date: null, /// дата начала договора
  affectionValue: null,
  premium: null,
  productId: 0, /// id продукта для оплаты
  confirm: false, /// Подтвердите, что объект не относится к категориям
  group: null, // 1-дом, 2-квартира
  city: '',
  raion: '',
  street: '',
  dom: '',
  kvartira: '',
  phone: '',
  insuredData: null,
  insuredsData: [],
};

const asylSlice = createSlice({
  name: 'asyl',
  initialState,
  reducers: {
    reset: () => initialState,

    addPeriod: (state: Draft<IAsylState>, action: PayloadAction<number>) => {
      state.period = action.payload;
    },

    addPremium: (state: Draft<IAsylState>, action: PayloadAction<number>) => {
      state.premium = action.payload;
    },

    addProductId: (state: Draft<IAsylState>, action: PayloadAction<number>) => {
      state.productId = action.payload;
    },
    addPhoneNumber: (
      state: Draft<IAsylState>,
      action: PayloadAction<string>
    ) => {
      state.phone = action.payload;
    },

    addCoverage: (state: Draft<IAsylState>, action: PayloadAction<number>) => {
      state.coverage = action.payload;
    },

    addAffectionValue: (
      state: Draft<IAsylState>,
      action: PayloadAction<number>
    ) => {
      state.affectionValue = action.payload;
    },

    addBeginDate: (
      state: Draft<IAsylState>,
      action: PayloadAction<string | number>
    ) => {
      state.begin_date = action.payload;
    },

    addConfirm: (state: Draft<IAsylState>, action: PayloadAction<boolean>) => {
      state.confirm = action.payload;
    },

    addAddress: (
      state: Draft<IAsylState>,
      action: PayloadAction<{
        _group: number;
        _city: string;
        _raion: string;
        _street: string;
        _dom: string;
        _kvartira: string;
      }>
    ) => {
      state.group = action.payload._group;
      state.city = action.payload._city;
      state.raion = action.payload._raion;
      state.street = action.payload._street;
      state.dom = action.payload._dom;
      state.kvartira = action.payload._kvartira;
    },

    addInsureds: (
      state: Draft<IAsylState>,
      action: PayloadAction<number[]>
    ) => {
      state.insureds = action.payload;
    },

    secondStepData: (
      state: Draft<IAsylState>,
      action: PayloadAction<{
        insuredData: IInsured;
        insuredsData: IInsured[];
      }>
    ) => {
      state.insuredData = action.payload.insuredData;
      state.insuredsData = action.payload.insuredsData;
    },
  },
});

export const {
  addPhoneNumber,
  addPremium,
  addProductId,
  addAddress,
  addConfirm,
  addPeriod,
  addCoverage,
  addAffectionValue,
  addBeginDate,
  addInsureds,
  secondStepData,
} = asylSlice.actions;
export default asylSlice.reducer;
